import {SelectButton} from './select-button';

const BENEFICIARY_SELECT_BUTTONS_FR: SelectButton<boolean>[] = [
  {label: 'Spécifiques', value: false},
  {label: 'Héritiers légaux', value: true},
];

const BENEFICIARY_SELECT_BUTTONS_EN: SelectButton<boolean>[] = [
  {label: 'Specific', value: false},
  {label: 'Legal heirs', value: true},
];

export const BENEFICIARY_SELECT_BUTTONS = {
  en: BENEFICIARY_SELECT_BUTTONS_EN,
  fr: BENEFICIARY_SELECT_BUTTONS_FR,
};
